/* eslint-disable @reatom/unit-naming-rule */
import { Result } from '@blade/std-lib'
import { pairRegistry } from '@root/entities/pair/atoms'
import { fetchTrendingPairsRequestAction } from '@root/features/trending-pairs/atoms/trending-requests'
import {
  DEFAULT_TRENDING_STRATEGY,
  trendingStrategyAtom,
} from '@root/features/trending-pairs/atoms/trending-strategy'

import { ExploreFilter } from '../../model'
import { ExploreFeedType } from '../../model/explore-feed-type'

import { reatomExploreTableBase } from './reatom-explore-table-base'

import type { PairModel } from '@root/entities/pair/atoms'
import type { TableData } from '@root/shared/ui-kit/data-table/atoms/reatom-data-table-state'

export const reatomExploreTableTrending = () => {
  return reatomExploreTableBase({
    feedType: ExploreFeedType.Trending,
    // Which ranking is on screen decides the rows as much as a filter does.
    reloadOn: trendingStrategyAtom,
    loadPairs: async (
      ctx,
      {
        sorting,
        pagination: { limit, offset },
        params: { filters, network, period },
      },
    ) => {
      const strategy = ctx.get(trendingStrategyAtom)

      const result = await ctx.schedule(() =>
        fetchTrendingPairsRequestAction(ctx, {
          filters: ExploreFilter.toPoolFiltersDto(filters, sorting, period),
          network,
          limit,
          offset,
          ...(strategy === DEFAULT_TRENDING_STRATEGY ? {} : { strategy }),
        }),
      )

      return Result.map(result, (value) => {
        const data: TableData<PairModel> = {
          data: value.data.map((it) => pairRegistry.resolveFromDto(ctx, it)),
          hasNext: value.meta.hasNext,
        }

        return data
      })
    },
  })
}
